module.exports = require("relaxed-json");